var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('budget-order-production-info'),_c('sale-info'),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }